<template>
  <div>
    <h2 class="txt-head">
      แก้ไขตำแหน่งงาน
    </h2>
    <v-divider
      class="mx-4"
      inset
      vertical
    ></v-divider>
    <v-layout class="row-menu-right mb-3 pl-3 pr-3" style="margin-right: -15%;">
    </v-layout>
    <div :class="(k+1)%2==0?'create-orgchart-roundbox-even mt-3':(k+1)%2!=0&&k!=0 ?'create-orgchart-roundbox-odd mt-3':'create-orgchart-roundbox-odd'" v-for="(input,k) in positionData" :key="k" style="text-align: center; margin-top: 1%;">
    <v-layout class="row ml-10">
      <v-col cols="2">
        <p :class="(k+1)%2==0?'create-orgchart-title-even':'create-orgchart-title-odd'" style="margin-top: 1.5%;">ชื่อตำแหน่ง</p>
      </v-col>
        <v-col cols="4" class="form-control">
          <v-text-field
            v-model="positionData.positionName"
            label="ชื่อเครือภาษไทย"
            class="mt-2"
            outlined
          ></v-text-field>
      </v-col>
      <v-col cols="1">
        <p :class="(k+1)%2==0?'create-orgchart-title-even':'create-orgchart-title-odd'" style="margin-top: 1.5%;">ชื่อบริษัท</p>
      </v-col>
        <v-col cols="4" class="form-control">
          <v-select
            v-model="positionData.companyName"
            :items="selectData"
            outlined
            label="เลือก บริษัท"
            class="mt-2"
          >
          </v-select>
      </v-col>
      <v-layout class="column">
        <!-- <v-col cols="" class="form-control">
        <v-btn icon color="green" class="add_button">
          <v-icon @click="add(k)" v-show="k == positionData.length-1">mdi-plus</v-icon>
        </v-btn>
      </v-col> -->
      <v-col cols="" class="form-control">
        <v-btn icon color="red" class="add_button">
          <v-icon @click="remove(k)" v-show="k || ( !k && positionData.length > 1)">mdi-delete</v-icon>
        </v-btn>
      </v-col>
      </v-layout>
      </v-layout>
  </div>
  <div class="text-right action-top-btn">
    <v-btn class="ma-2" tile color="red" dark @click="goBack()">ยกเลิก</v-btn>
    <v-btn class="ma-2" tile color="success" @click="submitData(positionData.positionName, positionData.companyName)">
      <v-icon left>mdi-pencil</v-icon> บันทัก
    </v-btn>
  </div>
  </div>
</template>

<script>
import { getSelectPosition, getDetailPosition, editPosition } from '@/API/API'
// import OverlayLoading from '@/components/_loading/overlay.vue'
// import { EventBus } from '@/EventBus'
import swal from 'sweetalert'

export default {
  name: 'create-new-department',
  components: {
    // OverlayLoading
  },
  data () {
    return {
      tokenUser: '',
      itemCompanyName: [],
      itemCompanyTitle: ['สายงาน', 'ฝ่ายงาน', 'ส่วนงาน', 'กลุ่มงาน', 'หน่วยงาน'],
      itemCompanyHeader: [],
      itemUser: [],
      selectCompanyName: '',
      selectCompanyTitle: '',
      selectCompanyHeader: null,
      searchUser: null,
      disableSelectCompanyHeader: true,
      loading: true,
      itemNode: [],
      isLoading: false,
      showInvisSave: false,
      canSave: false,
      nameTh: '',
      nameEng: '',
      CompanyData: '',
      selectData: [],
      chkDuplicate: false,
      positionData: [{
        positionName: '',
        companyName: ''
      }],
      tab: null,
      rulesGroupCompanyNameTh: [
        v => !!v || 'กรุณากรอก ชื่อเครือบริษัท'
      ],
      rulesGroupCompanyNameEng: [
        v => !!v || 'กรุณากรอก ชื่อเครือบริษัท'
      ],
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ]
    }
  },
  created () {
    this.tokenUser = this.$store.state.token
    if (this.tokenUser) {
      if (!this.$route.params.id) this.$router.go(-1)
      if (this.$route.params.id) {
        this.propsEmpId = this.$route.params.id
        this.propsEmpPositionId = this.$route.params.id
        this.propsitems = this.$route.params.item
        this.positionData.positionName = this.$route.params.item.positionName
        this.positionData.companyName = this.$route.params.item.companyName
        // this.initGetOrgChartById()
      }
    }
    this.initSelectData()
  },
  watch: {
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    async initGetOrgChartById () {
      this.loading = true
      const obj = {
        positionId: this.propsEmpId
      }
      try {
        const res = await getDetailPosition(obj, this.tokenUser)
        // console.log('Res Position', res)
        if (res.success) {
          this.positionData.positionName = res.result.positionName
          this.positionData.companyName = res.result.positionName
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      const token = this.tokenUser

      try {
        const res = await getSelectPosition(token)

        if (res.success) {
          if (res.result.length) {
            this.selectData = res.result[0].companyName
          }
          // console.log('Select Positionn', res.result[0].companyName)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async submitData (position, company) {
      this.propsitems = this.$route.params.item
      const obj = {
        positionId: this.propsEmpId,
        positionName: position,
        companyId: this.propsitems.companyId
      }
      if (position === '') {
        swal('คำเตือน', 'กรุณากรอกชื่อตพแหน่ง', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        try {
          const res = await editPosition(obj, this.tokenUser)
          // console.log('Resr', res)
          if (res.success) {
            // console.log('Search Value Insert', res)
            // console.log(res.result)
            swal('สำเร็จ', 'แก้ไขสำเร็จ', 'success', {
              button: false,
              timer: 2000
            })
            this.$router.go(-1)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        } catch (error) {
          console.log(error)
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        } finally {
          this.loading = false
        }
      }
    },
    add () {
      this.positionData.push({
        positionName: '',
        companyName: ''
      })
      // console.log(this.positionData)
    },
    remove (index) {
      this.positionData.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.round1 {
  border: 1px solid rgb(165, 163, 163);
  border-radius: 5px;
}
.right {
  margin: auto;
  width: 60%;
  border: 3px solid #73AD21;
  padding: 10px;
}
</style>
